import { ResultOf } from "@graphql-typed-document-node/core";
import { useMemo } from "react";
import { CombinedError, useQuery } from "urql";

import { getFragmentData, graphql } from "@/gen";

const UseRound = graphql(`
    fragment UseRound on Round {
        __typename
        id
        title
        scheduledStartAt
        lastGameScheduledStartAt
        evaluationSurgeProtectionOverride
        tournamentStage {
            id
            tournament {
                id
            }
        }
        roundSyncerConfig {
            id
            pgnProviderType
            pollPgnSource
            streamingPgnSource
            pollStart
            pollEnd
            pollCreateGames
            livechesscloudRoundId
            livechesscloudRoundNumber
            pgnDelaySecs
        }
    }
`);

export const importChessresultsPairingsForRoundMutation = graphql(`
    mutation ImportChessresultsPairingsForRound($input: ImportChessresultsPairingsForRoundInput!) {
        importChessresultsPairingsForRound(input: $input)
    }
`);

export const setAllGamesScheduledStartAtToRoundMutation = graphql(`
    mutation SetAllGamesScheduledStartAtToRound($roundId: UUID!) {
        setAllGamesScheduledStartAtToRound(roundId: $roundId)
    }
`);

export const recalculateRoundTrialResultsMutation = graphql(`
    mutation RecalculateRoundTrialResults($roundId: UUID!) {
        recalculateRoundTrialResults(roundId: $roundId) {
            totalTrialsChecked
            trialsUpdated
            trialsFailed
        }
    }
`);

export type RoundT = ResultOf<typeof UseRound>;

export const useRound: (roundId?: string) => {
    round: RoundT | null | undefined;
    loading: boolean;
    error: CombinedError | undefined;
    refetch: () => void;
} = (roundId?: string) => {
    const [result, refetch] = useQuery({
        query: graphql(`
            query roundQuery($id: UUID!) {
                round(id: $id) {
                    id
                    ...UseRound
                }
            }
        `),
        variables: {
            id: roundId!,
        },
        pause: !roundId,
    });

    const round = useMemo(() => getFragmentData(UseRound, result.data?.round), [result.data]);

    return {
        round: round,
        loading: result.fetching,
        error: result.error,
        refetch,
    };
};
